module.exports = __webpack_public_path__ + "bba7568d348444b37d63af5fac832d34.svg";